module.exports = __webpack_public_path__ + "static/kereszty_dentalmikroskop-d17e07dc7bab2eb344767e69ad7aa121.jpg";